import { Component, TemplateRef, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AdminProfileDataService } from 'src/app/admin-profile-data.service';
import { EncryptionService } from 'src/app/encryption.service';
import { VendorService } from 'src/app/services/vendor.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { ExamService } from '../exam.service';
import { CandidateService } from 'src/app/services/candidate.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

import { HeaderLatestComponent } from '../../home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from '../../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-online-exam',
  templateUrl: './online-exam.component.html',
  styleUrl: './online-exam.component.scss',
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatRadioModule, MatButtonModule, MatIconModule, MatDialogModule, HeaderLatestComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class OnlineExamComponent {
  [key: string]: any;
  constructor() {
  }

}
